import React, { Component } from 'react'
import { EditorState } from 'draft-js'
import RichTextEditor from '../'
import { StateView, HtmlView, LogEditorState, LogContentState } from './DebugViews'
import SelectTemplate from './SelectTemplate'
import { blockRendererFn } from '../plugins/colorBlock'
import TEMPLATES, { TEMPLATE_NAMES, convertTemplateToEditorState } from '../message-templates'
import './styles.css'

class Auditor extends Component {
  constructor(props) {
    super(props)

    const templateName = 'basicJro'
    const bodyState = EditorState.createEmpty()

    this.state = {
      bodyState,
      templateName,
      showExtraButtons: false,
    }
  }

  updateTemplateName = (ev) => {
    this.setState({ templateName: ev.target.value })
  }

  resetStateWithTemplate = (ev) => {
    ev.preventDefault()

    const { templateName } = this.state
    const editorState = !TEMPLATES[templateName] ?
      EditorState.createEmpty() :
      convertTemplateToEditorState(templateName)

    this.updateEditorState(editorState)
  }

  updateEditorState = (editorState) => { this.setState({ bodyState: editorState }) }

  handleCheck = () => {
    this.setState({ showExtraButtons: !this.state.showExtraButtons })
  }

  render() {
    const { bodyState, showExtraButtons } = this.state

    return (
      <div className="Auditor">
        <div className="panel">
          <SelectTemplate
            selectedOption={this.state.templateName}
            handleSelect={this.updateTemplateName}
            templates={TEMPLATE_NAMES}
            handleClick={this.resetStateWithTemplate}
          />
          <LogEditorState state={bodyState} buttonText="Log editor state" />
          <LogContentState state={bodyState} buttonText="Log body state" />
          <label htmlFor="showExtraButtons" onChange={this.handleCheck}>
            {showExtraButtons ? 'showing buttons' : 'hiding buttons'}
            <input
              name="showExtraButtons"
              type="checkbox"
              value={showExtraButtons}
            />
          </label>
        </div>
        <RichTextEditor
          showExtraButtons={showExtraButtons}
          editorState={bodyState}
          plugins={[]}
          updateBodyState={this.updateEditorState}
          blockRendererFn={blockRendererFn}
        />
        <StateView editorState={bodyState} />
        <HtmlView editorState={bodyState} />
      </div>
    )
  }
}

export default Auditor



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/Auditor/index.js